/* eslint-disable no-template-curly-in-string */
module.exports = {
  _runbook:
    "https://www.notion.so/gatsbyjs/Working-with-text-copies-in-com-code-b540a036ec7f4298af2d353a59fc84bf",
  auth: {
    morphemes: {
      github: "GitHub",
      gitlab: "GitLab",
      bitbucket: "Bitbucket",
      google: "Google",
      workos: "WorkOS",
      githubEnterprise: "GitHub Enterprise",
      gitlabSelfManaged: "GitLab Self Managed",
    },
    actions: {
      signUpWith: "Authorize with {oauthProvider}",
      logInWith: "Log in with {oauthProvider}",
      continueToProvider: "Continue to your provider",
      continueWith: "Continue with {oauthProvider}",
    },
    headers: {
      signUpPage: "Select Your VCS Provider",
      logInPage: "Log in to Gatsby Cloud",
      sso: "Single Sign-On",
      logInTo: "Log in to <strong>Gatsby Cloud</strong>",
      signUpFor: "Sign up for <strong>Gatsby Cloud</strong>",
    },
    messages: {
      loginIntroText: "Stop managing content. Start telling your story.",
      signupIntroText:
        "Authorizing with your VCS (version control system) provider is how you'll connect your site and also sign in to Gatsby Cloud.",
      termsAndPolicy:
        "By signing up, you agree to our <termsLink>Terms of Service</termsLink> and <privacyLink>Privacy Policy</privacyLink>",
      haveAnAccount: "Already have an account? <link>Log in</link>",
      noAccount: "Don't have an account? <link>Sign up</link>",
      ssoLogin: "Or use <link>Single Sign-On</link>",
      notUsingSsoBackToLogin: "Not using SSO? Back to <link>Log in</link>",
      backToLogin: "Back to <link>Log in</link>",
      notUsingSSO: "Not using SSO?",
      ssoLoginTestSuccess: "You have successfully tested your Single Sign-On.",
      byClickingContinueYouAgree:
        "By clicking continue, you agree to our <termsLink>Terms of Service</termsLink> and <privacyLink>Privacy Policy</privacyLink>.",
    },
    labels: {
      enterYourEmail: "Enter your email address",
    },
  },
  organizations: {
    morphemes: {
      organization: "workspace",
    },
    actions: {
      reactivate: "Reactivate idle workspace",
      createOrganizationButton: "Create new workspace",
      backToHomepage: "Go back to the homepage",
    },
    headers: {
      yourOrganization: "Your workspace",
      contributorAccessTo: "CONTRIBUTOR ACCESS TO",
      zeroOrganizationsHeader: "You don't have any workspaces set up - yet!",
      noAccess: "You do not have access to this workspace.",
    },
    messages: {
      loadingDetails: "loading your workspace details...",
      contactTheOwner:
        "Please contact the workspace owner to request permission.",
      afterYourTrialEnds:
        "After your trial ends, you will automatically be switched to the Free Plan.",
    },
  },
  createOrganization: {
    actions: {
      editName: "Edit name",
      changePlan: "Change plan",
      createPaidSpace: "Pay and create workspace",
      createFreeSpace: "Create workspace",
    },
    headers: {
      wizardHeader: "Create a workspace",
      setup: "Set up your workspace",
      pickPlan: "Pick a plan for your workspace",
      review: "Review your workspace",
    },
    messages: {
      alreadyHasFreeWorkspace:
        "You can own one free or trial workspace — you've already created yours at <link>{workspaceName}</link>.",
      setupDescription:
        "A workspace can be a team, company, or any other way you want to organize your projects. Don't worry, you can always change the name of your workspace later.",
      pickPlanDescription:
        "All plans allow you to create an unlimited number of sites. If you need a custom plan or want to try out a few select features, please <link>contact us</link>.",
      reviewDescription:
        "Don't worry, you can always change all of this information later.",
      customPlan:
        "Don't see a plan that fits your needs? <link>Contact us</link> for a customized plan built for you.",
    },
    labels: {
      orgName: "Name your workspace",
      reviewName: "Workspace name",
      reviewPlan: "Selected plan",
      reviewTotal: "Total payment",
      setupStep: "Set up workspace",
      pickPlanStep: "Pick a plan",
      reviewStep: "Review",
    },
  },
  editOrganization: {
    labels: {
      orgName: "Workspace name",
    },
  },
  loginErrors: {
    headers: {
      oauthError: "There was an issue accessing {oauthProvider}",
    },
    messages: {
      oauthError:
        "<strong>Something is currently interfering with establishing a secure connection with {oauthProvider}.</strong> Maybe they are having trouble over there? Please try to reload this page in a few minutes.",
      ssoError:
        "It looks like your domain is not configured for Enterprise SSO on Gatsby Cloud. If you are interested in adding it to your Workspace, please reach out to our team using the link below.",
      ssoAuthError:
        "It looks like your domain is not configured for Enterprise SSO on Gatsby Cloud. If you are interested in adding it to your Workspace, please <button>contact support</button>.",
    },
    invitationExpired: {
      heading: ["Your invitation has expired"],
      message: [
        "We are sorry, but this invitation has expired",
        "If you need assistance, please email support at support@gatsbyjs.com.",
      ],
      label: "Sign in to Gatsby Cloud ",
    },
    invitationAccepted: {
      heading: ["Your invitation has already been accepted"],
      message: [
        "We are sorry, but this invitation has been accepted",
        "If you need assistance, please email support at support@gatsbyjs.com.",
      ],
      label: "Sign in to Gatsby Cloud ",
    },
    invitationError: {
      heading: ["Your invitation token has an error", "so we can not find it"],
      message: [
        "We are sorry, but we could not find a matching token in our database.",
        "Our team has been notified of the error and will check on it. We will get back to you as soon as possible.",
      ],
      label: "Got it!",
    },
    invitationRequired: {
      heading: ["You must have an invitation", "to access Gatsby Cloud"],
      message: [
        "We are sorry, but we could not find a matching invitation in our database.",
        "Please sign up for your personal invitation to Gatsby Cloud.",
      ],
      label: "Sign up for Gatsby Cloud ",
    },
    invitationMismatch: {
      heading: ["Your invitation link", "was already used"],
      message: [
        "We are sorry, but an invitation link is valid one time. Invitation links can not be passed along.",
        "Please sign up for your personal invitation to Gatsby Cloud.",
      ],
      label: "Sign up for Gatsby Cloud ",
    },
    previewAccess: {
      heading: ["You do not have permissions to view this Preview"],
      message: [
        "If you need assistance, please email support at support@gatsby.com.",
      ],
      label: "Got It",
    },
    blocked: {
      heading: ["This account has been blocked"],
      message: [
        "If you think you have been blocked by mistake please email support at support@gatsbyjs.com.",
      ],
      label: "Got it",
    },
    ticketNotFound: {
      heading: ["Your login has expired"],
      message: ["We are sorry, but this login has expired."],
      label: "Got it",
    },
  },
  modalErrors: {
    gotIt: "Got it",
    contactSupport: "Contact support",
    emailSupport:
      "If you need assistance, please email support at support@gatsbyjs.com.",
    noGatsby: {
      heading: ["No Gatsby site found in the repo"],
      message: [
        "We could not find a Gatsby site in the selected repository.",
        "Your repository must contain one Gatsby project.",
        "If you are sure that you got everything configured correctly, please contact our support — we are happy to help however we can!",
      ],
    },
    invalidVersion: {
      heading: [
        "Gatsby package version found in repo is incompatible with Gatsby Cloud",
      ],
      message: [
        "We have detected the Gatsby package version in the selected repository is incompatible with Gatsby Cloud.",
        "Please upgrade your package to version 2.1.0 or above.",
        "If you are sure that you got everything configured correctly, please contact our support — we are happy to help however we can!",
      ],
    },
    blacklistedDeps: {
      heading: ["Your repository has one or many harmful packages."],
      message: [
        "We have detected the use of harmful packages within this repository. We are unable to create your site.",
        "If you are sure that you got everything configured correctly, please contact our support — we are happy to help however we can!",
      ],
    },
    noOrganizationPermission: {
      heading: ["You do not have permission to create this site"],
      message: [
        "You do not have adequate permission to create sites for this workspace. Contact the owner for an invitation.",
        "If you are sure that you got everything configured correctly, please contact our support — we are happy to help however we can!",
      ],
    },
    defaultError: {
      heading: ["Something went wrong"],
      message: [
        "Woops! Getting in trouble? — we are happy to help you!",
        "Gatsby Cloud is currently unavailable. Please check back soon.",
      ],
    },
    unAuthorized: {
      heading: "Authorization Error",
      subHeading: "It looks like there's an authorization error",
      content:
        "It appears that you don't have access to that resource. Please check with the project administrator, or contact support for assistance",
    },
  },
  sites: {
    morphemes: {
      site: "site",
    },
    labels: {
      learnAboutDeletingSite: "Learn about deleting site",
      transferPending: "Transfer pending",
      siteTransferred: "Shared",
    },
    actions: {
      addSite: "Add a site",
      backToHomepage: "Go back to the homepage",
      learnMore: `Learn more`,
      viewErrors: "View errors",
      viewFullReport: "View full report",
      viewFullLighthouseReport: "View full Lighthouse report",
    },
    headers: {
      noSites: "You don't seem to have any sites",
      noSitesViewer: "No sites in this workspace yet",
      noAccess: "You do not have access to this site.",
      lighthouse: "Lighthouse",
      hostedOnGatsbyCloud: "Hosted on Gatsby Cloud",
    },
    messages: {
      noSitesDescription: "Add a site and have it up and running in minutes.",
      noSitesDescriptionViewer:
        "Owners and editors can add sites in the workspace.",
      noSites: "No sites in this workspace",
      noMatchingSites: "No matching sites in this workspace",
      contactTheOwner: "Please contact the site owner to request permission.",
      loadingScores: "Loading the scores...",
      somethingWentWrongWhenTryingToLoadTheLighthouseScores:
        "Something went wrong when trying to load the Lighthouse scores",
      reportNotEnabled:
        "No report for this build. Go to <link>site settings</link>  to enable the feature.",
      noReportForSite: "No report for this build yet.",
      goToSiteDetails: "Go to site details for {siteName}",
      domainIsNotValidated: "{domain} is not validated",
      withDomainsNames: "With domains names",
    },
    createSiteButton: "Create new site",
    addNewSite: "Create new site",
    updated: "Updated",
    deleteSite: "Delete site",
    cancel: "Cancel",
    deleteSiteConf: "Are you sure you want to delete ",
    yesDeleteSite: "Yes, delete this site",
    deleteSiteInfo:
      "You can delete a site at any time, but you won't be able to access the Gatsby site URL anymore.",
    losePreviewUrl: "You will no longer be able to view your site URL.",
    deleteSiteNoPermission:
      "You do not have permissions to delete this site. Please contact the site's owner.",
    deletedSuccessfully: "deleted successfully",
  },
  siteSettings: {
    headers: {
      environmentVariables: "Environment variables",
      buildTypes: `Build types`,
      buildFeatures: `Build features`,
      domains: `Domains`,
      hostingIntegrations: `Hosting integrations`,
      GatsbyHosting: `Gatsby hosting`,
      dataSources: "Data sources",
      hosting: "Hosting",
      preview: "Preview",
      imageCDN: "Image CDN",
      logDrains: "Log drains",
      dataLayer: "Data layer",
      contentHub: "Content Hub",
    },
    messages: {
      sitePrefixHint:
        "Only lower case alphabetical characters and numbers are allowed.",
      wrongSitePrefix: "The site prefix is not valid or already exists.",
      yourDefaultHostedSiteWillBeAt:
        "Your default hosted site will be at <strong>{prefix}.gatsbyjs.io.</strong>",
      editingSitePrefixWillRequire:
        "Editing the site prefix could require you to update your DNS settings.",
      sourceContent100Faster:
        "Source content up to 100x faster:  <link>Enable Accelerated Sourcing</link>",
    },
  },
  siteBuildsSettings: {
    labels: {
      enableBuilds: "Enable builds",
      enableBurstBuilds: "Enable Burst Mode builds",
      enableIncrementalDeploysProduction: `Enable Incremental Deploys`,
      enableBranchAndPullRequestBuilds: `Enable branch and pull request builds`,
      enableBuildChecks: "Enable build checks",
      enableIncrementalBuilds: "Enable cloud builds",
      enableAutomaticDeploys: "Enable automatic deploys",
      learnAboutCloudBuilds: "Learn about cloud builds",
      learnAboutAutomaticDeploys: "Learn about automatic deploys",
      enableMerlinPullRequestSourcing: "Enable Accelerated Sourcing",
      enableSlicesAPI: `Optimize Slices API`,
      enableGatsbjsio: `Enable Unified Hosting`,
    },
    messages: {
      enableIncrementalDeploysProduction: `Incrementally deploy changes for branch and pull request builds`,
      incrementalBuildsDisabled:
        "Cloud builds are not available for {freePlanName} plan",
      automaticDeploysDisabledHosting:
        "Customizable only for Gatsby Hosting, <link>turn on Gatsby Hosting</link> to unlock the feature.",
      automaticDeploysDisabledPlan:
        "Customizable only with a {plan} plan. <link>Upgrade your plan</link> to unlock the feature.",
      runsProductionAndPullRequestBuilds:
        "Runs branch and pull request builds for all changes from your codebase and data sources.",
      increasesBuildSpeeds:
        "Increases build speeds by running multiple engines for specific types of builds.",
      runsLighthouseCheck:
        "Runs a Lighthouse check for the homepage of every successful site build.",
      runsVcsCheckSuites:
        "Runs VCS check suites for every successful site build.",
      incrementalBuildsForContentUpdates:
        "Incremental builds for all content updates.",
      notAvailableForFreePlan:
        "Not available for Free plans. <link>Upgrade</link>",
      deploysAllSuccessfulProductionBuilds:
        "Deploys all successful production builds to the CDN.",
      notCustomizableForYourPlan:
        "Not customizable for your plan. <link>Upgrade</link>",
      onlyCustomizableIfHostingOn:
        "Only customizable if you've turned on <link>Hosting</link>.",
      onlyCustomizableOnEnterprisePlan:
        "Only customizable for Enterprise plans. <link>Upgrade</link>",
      incDeploysRequiresLatestGatsbyVersion:
        "Incremental Deploys requires Gatsby 4 or higher <link>Read more</link>",
      incDeploysDefaultBanner:
        "Incremental Deploys doesn't work with all sites.",
      merlinSourcingRequiresGatsbyVersion:
        "Requires Gatsby 4.20 or higher and only works with some source plugins.",
      merlinSourcingDefaultBanner:
        "Gatsby Cloud will store your sourced data so you only need to source once. Only works for select source plugins.",
      enableMerlinPullRequestSourcing:
        "Source content for PR builds up to 100x faster",
      enableSlicesAPI: `Enable optimizations for the Slices API during cloud builds`,
      enableSlicesAPILatestGatsbyVersion:
        "The Slices API requires Gatsby 5 or higher. <link>Read more</link>",
      enableSlicesAPIGatsbyJSIO: `These optimizations require Unified Hosting.`,
      enableGatsbjsio: `Deploys Preview and Pull Request builds to a faster, unified architecture.`,
    },
  },
  sitePreviewSettings: {
    headers: {
      configureWidget: "Configure Preview Widget",
      gatsbyCloudWebhook: "Gatsby Cloud Webhook",
    },
    labels: {
      enablePreviewBuilds: "Enable CMS Preview builds",
      enableIncrementalDeploys: "Enable Incremental Deploys",
      previewUpdateType: "Choose how CMS preview gets updated",
      previewUpdateTypeOptionAuto: "Automatic Preview Builds",
      previewUpdateTypeOptionManual: "Manual Preview Builds",
      learnAboutCmsPreviewBuilds: "Learn about CMS Preview builds",
      learnAboutIncrementalDeploys: "Learn about Incremental Deploys",
    },
    messages: {
      gatsbyCloudWebhookDescription:
        "Copy and paste this link in the appropriate part of your CMS to trigger preview builds.",
      previewUpdateTypeOptionAutoDescription:
        "Automatically build a new preview when content is updated.",
      previewUpdateTypeOptionManualDescription:
        "Allow users to manually trigger a rebuild of their preview when they are ready.",
      runsBuildsForContentChanges:
        "Runs production-grade builds for all draft content changes triggered in your CMS.",
      deploysOnlyContentUpdateChanges:
        "Deploys only the changes for each content update.",
      notAvailableForFree: "Not available for Free plans. <link>Upgrade</link>",
      requiresGatsby4: "Requires Gatsby 4 or higher. <link>Read more</link>",
    },
  },
  sitesList: {
    headers: {
      noMatchingSites: "No matching sites in this workspace",
    },
    labels: {
      repositoryLink: "View repository",
      repositoryLinkAria: "View repository on {provider}",
      searchSites: "Search sites (searching is case-sensitive)",
    },
    messages: {
      noSites: "No sites in this workspace",
      noMatchingSites:
        'Sorry, we couldn\'t find any sites matching "{searchTerm}". Searching is case-sensitive.',
    },
  },
  header: {
    actions: {
      createOrganization: "Create a workspace",
    },
    labels: {
      currentOrgIndicator: "(current workspace)",
    },
    title: "Cloud",
    loggedInAs: "Logged in as",
    userSettings: "User Settings",
    documentation: "Documentation",
    cloudDocumentation: "Gatsby Cloud",
    ossDocumentation: "Gatsby Open Source",
    communityForum: "Community Forum",
    statusPage: "System Status",
    productRoadmap: "Product Roadmap",
    needHelp: "Need help? Drop us an email:",
    signOut: "Sign out",
    allOrganizations: "All Workspaces",
    youDontHaveOrg: "You don't have any workspaces yet.",
  },
  sourceControl: {
    morphemes: {
      github: "GitHub",
      gitlab: "GitLab",
      bitbucket: "Bitbucket",
      google: "Google",
      workos: "WorkOS",
      githubEnterprise: "GitHub Enterprise",
      gitlabSelfManaged: "GitLab Self Managed",
    },
  },
  createSiteConfiguration: {
    headers: {
      basicConfiguration: "Basic Configuration",
    },
    actions: {
      buildSite: "Build Site",
      goBack: "Go Back",
    },
    messages: {
      toWorkspace: "to the <span>{workspaceName}</span> workspace",
      addRepository: "Add {repositoryName}",
    },
    labels: {
      steps: [
        "Basic Configuration",
        "CMS Integrations",
        "Environment Variables",
      ],
    },
  },
  createSite: {
    actions: {
      selectInstallation: "Select destination",
      backToWorkspace: "Go to workspace",
      switchToOtherProvider: "Switch provider",
      addSelfHostedGitProvider: "Add self-hosted Git provider",
      addSelfHostedGithubConnection: "Add Enterprise GitHub Server",
      addSelfHostedGitlabConnection: "Add Self Managed GitLab Server",
    },
    headers: {
      wizardTitle: "Add a new site",
      addSite: "Add a site",
      unauthenticatedWizardSubheading:
        "To deploy a new Gatsby Cloud site, connect a Git repository or use a Gatsby Starter.",
      zeroInstallations: "Where should we host this new project?",
      authenticatedWizardSubheading:
        "Connect a Git repository or pick a Gatsby Starter to deploy a new Gatsby Cloud site.",
      noAccessTitle:
        "You do not have permissions to add a site in this workspace",
    },
    labels: {
      pickSiteType: "How do you want to add a new site?",
      siteTypeProvision: "Start from a Template",
      siteTypeImport: "Import from a Git repository",
      siteTypeSupportedProviders: "Supported source control providers",
      selectProvider:
        "Select a Git provider to connect a Git repository containing your Gatsby site:",
    },
    messages: {
      autoAddedVariables:
        "We automatically added these based on your connected integrations. <link>To learn more, refer to this documentation</link> if you are unsure about this step or want to learn more about environment variables.",
      provisionDescription:
        "Choose starter, connect a CMS, and Gatsby does the rest for you. Templates are available on GitHub only.",
      importDescription:
        "Connect your site from an existing Git repository to get access to powerful features, including Gatsby Builds & Previews",
      openedSourceControlAuth:
        "We just opened a new browser window to authenticate with {provider}. Accidentally closed the window?",
      selfHostedSourceControlAuth:
        "To continue, please follow the link below to install the GitHub App to the organizations on your {provider} server.",
      addNewGithubInstallation:
        "Looks like you don't have any installations yet.",
      pendingSourceControlAuth:
        "Thank you. Please wait a few moments while we load your {provider} information.",
      noAccessDescription:
        "Please contact your workspace owner to request permission.",
      availableOnlyForGitHubUsers: "Available only for GitHub users.",
      learnMore:
        "Learn more about <link>the permissions we're asking for</link>",
      workspaceName: "to the <span>{workspaceName}</span> workspace",
    },
    title: "Create a new site",
    chooseOrganization: "Select an organization",
    addIt: "Add it",
    searchPlaceholder: "Search your {provider} repositories",
    organization: "Organization",
    cancel: "Cancel",
    previewSite: "Preview Site",
    addVariable: "Add Variable",
    bulkAddVariables: "Bulk Add Variables",
    key: "Key",
    value: "Value",
    remove: "Remove",
    cantBeEmpty: "Can't be empty",
    setUpSite: "Set up site for ",
    continue: "Continue",
    needHelp: "Need help with environment variables of webhook setup? Go to",
    stepTwo: "Step 2: Add integrations",
    setupLater: "now or setup integrations later in your site settings",
    goBack: "Go back",
  },
  provisionSite: {
    messages: {
      creatingRepository:
        "We are creating a Git repository to ensure you can update your site after deploying it. Every push to this repository will automatically trigger a new build.",
      creatingSite: "Creating your site...",
      loadingSourceProviderTeams: "Loading your repositories...",
      updatePermissions: "Update Permissions",
    },
    cmsTab: "CMS & starter",
    starterTab: "Starter",
    repositoryTab: "Repository",
    summaryTab: "Summary",
    pickCMS: "Pick a Content Management System (CMS) provider",
    pickStarter: "Pick a Starter",
    nameYourProject: "What should we call your new project?",
    chooseDestination: "Choose a destination:",
    chooseOrganization:
      "Choose the GitHub organization to create the repository for your new site. Can't find your organization?",
    openWindowGithubAuthentication:
      "We just opened a new browser window to authenticate with GitHub. Accidentally closed the window?",
    configureRepository: "Configure your new repository",
    waitAMoment:
      "Thank you. Please wait a few moments while we load your GitHub information.",
    addIt: "Add it",
    organizations: "Organizations: ",
    summary: "Successfully set up",
    instanceAvailable: "Once your site is available, editing content in",
    update: "will instantly update your site. Manage your content in",
    here: "here: ",
    repository: "We create a repository on GitHub on your behalf",
    createdRepo: "We created a repository on GitHub on your behalf:",
    integrations:
      "We are adding more starters and CMS integrations soon—stay tuned!",
    repositoryName: "A repository named ",
    created: " will be created under the ",
    organization: " organization ",
    connectCms: "Connect to your CMS Provider",
    connectCmsDescription:
      "To ensure a seamless integration, please authorize access to a CMS provider.",
    connectCmsTab: "Connect CMS",
    manageContent: "Manage your content in ",
    contentfulSpace: "A contentful space named ",
    contentfulOrg: "Contentful organization",
    contentfulDefaultOrg: "your Contentful default organization",
    projectNamed: "A project named",
    createdCms: "will be created in your",
  },
  cmsIntegrations: {
    title: "Optional integrations for your site, ",
    intro:
      "Connecting to a CMS will make sure you have an accurate preview version of your site (a Gatsby Cloud preview instance).",
    timingCaveat:
      "Not ready yet? That's ok! You can add multiple data sources at any time through the site settings.",
    connect: "Connect",
    hideDetails: "Hide details",
    skipStep: "Skip this step",
    details: "Details",
    documentation: "Read more about integrations",
    moreIntegrations:
      "We are adding more integrations soon and will keep you updated!",
    setupSite: "Set up your site",
    edit: "Edit",
    editIntegrations: "Edit Integrations",
    zeroState: "There are zero CMS integrations set up for this site yet.",
    addIntegration: "Add Integration",
    connected: "Connected",
    integrations: "We are adding more CMS integrations soon—stay tuned!",
    manualIntegrations: "Manual Integrations",
    manualIntegrationsSubheading:
      'Integrations that must be setup manually. Find the information for your CMS below, open the "Setup instructions" in a new tab so you can refer to them later, and then click "Skip this step" at the bottom of this page.',
    manualIntegrationsDesc:
      'Please click "Setup instructions" to open in a new tab, click "Skip this step" below, and follow the instructions to manually setup your site.',
  },
  cmsIntegration: {
    actions: {
      authorize: "Authorize",
      continue: "Continue",
    },
    headers: {
      connectIntegration: "{vendorName} Integration",
      connectIntegrationLong: "Configure integration with {vendorName}",
    },
    labels: {
      contentfulOrg: "Contentful organization",
      contentfulSpace: "Contentful space",
      contentfulSpacePlaceholder: "Select space",
      cosmicJsAuthToken: "Authentication token",
      cosmicJsBucket: "Bucket",
      datoCmsProject: "Project",
      sanityProject: "Sanity project",
      sanityDataset: "Sanity dataset",
      sanityDatasetPlaceholder: "Select dataset",
      shopifyStoreUrl: "Store Url",
      shopifyPassword: "Private app password",
    },
    messages: {
      shopifyFindPrivateAppCreds:
        "Login to your Shopify store and go to Apps → Manage private apps. Select the private app you created when configuring the Shopify source plugin. Use these details for authorization below.",
      shopifyStoreUrlInstructions:
        "Login to your Shopify store and go to Online Store → Domains. Enter the complete subdomain for your store's myshopify.com domain. For example, delicious-brews.myshopify.com.",
      shopifyConfirmIntegrationDetails:
        "Review your shop configuration data source for <strong>{siteName}</strong>.",
      authorizationRequired:
        "We need authorization to connect to <strong>{siteName}</strong>.",
      authorizationRequiredToProvision:
        "Please authorize Gatsby Cloud to be able to populate a content model and content in {cmsVendor} for your site <strong>{siteName}</strong>.",
      integrationUpdated: "Site integration updated successfully",
      chooseContentfulDataSource:
        "Choose a Contentful space to use as the data source for <strong>{siteName}</strong>.",
      chooseContentfulOrgDataSource:
        "Choose a Contentful organization to use as the data source for <strong>{siteName}</strong>.",
      refreshContentfulDataSource:
        "<a>Refresh Contentful account data</a> to see organizations and spaces created after opening this dialogue.",
      chooseCosmicJsDataSource:
        "Choose a CosmicJS bucket slug to use as the data source for <strong>{siteName}</strong>.",
      chooseDatoCmsDataSource:
        "Choose a DatoCMS project to use as the data source for <strong>{siteName}</strong>.",
      chooseSanityDataSource:
        "Choose a Sanity dataset to use as the data source for <strong>{siteName}</strong>.",
      cosmicJsAuthTokenInstructions:
        "Log into CosmicJS and go to <link>Account Settings → Authentication</link> to get your authentication token.",
      deployNowProvisionSelectEmptyDataSource:
        "If you elect to run the <code>gatsby-provision</code> script, Gatsby Cloud will create content models example content in the selected {cmsProjectName}. We recommend creating an empty, bespoke {cmsProjectName} to avoid potential conflict with existing content and content models.",
      deployNowGatsbyProvisionHelpTextForCmsVendor:
        "We detected a <code>gatsby-provision</code> script in this repository. Once you connect your {cmsVendor} account, Gatsby can copy the site's associated content into one of your {cmsVendor} {cmsProjectNamePlural} if you elect to run the script.",
      deployNowGatsbyProvisionLearnMore:
        "Learn more about <code>gatsby-provision</code> in the <a1>Gatsby Provision for {cmsVendor} package README</a1> or in <a2>Gatsby Cloud's {cmsVendor} Integration docs</a2>.",
      loadingContentfulSpaces: "Loading your spaces…",
      loadingCosmicJsBuckets: "Loading your buckets…",
      loadingDatoCmsProjects: "Loading your projects…",
      loadingSanityProjects: "Loading your projects…",
      refetchContentfulAccountData:
        "<a>Refresh Contentful account data</a> to see organizations and spaces created after opening this dialogue.",
      refetchSanityAccountData:
        "<a>Refresh Sanity account data</a> to see projects and datasets created after opening this dialogue.",
      validationContentfulOrgRequired:
        "You must select a Contentful organization to continue",
      validationContentfulSpaceRequired:
        "You must select a Contentful space to continue",
      validationCosmicJsBucketRequired: "You must select a bucket to continue",
      validationCosmicJsAuthTokenRequired:
        "Authentication token required to continue",
      validationDatoCmsProjectRequired: "You must select a project to continue",
      validationShopifyShopNameRequired: "Shop name required to continue",
      validationShopifyShopPasswordRequired:
        "Shop Password required to continue",
      validationShopifyShopAPIKeyRequired: "Shop API Key required to continue",
      validationSanityProjectRequired:
        "You must select a Sanity project to continue",
      validationSanityDatasetRequired:
        "You must select a Sanity dataset to continue",
    },
  },
  productionView: {
    deploysTo: "Deploys to ",
  },
  build: {
    headers: {
      logs: "Logs",
      rawLogs: "Raw logs",
      functions: "Functions",
      ssrLogs: "SSR logs",
    },
    labels: {
      published: "Published",
      dsg: "DSG",
      ssr: "SSR",
      ssg: "SSG",
      func: "Func",
      burst: "Burst",
      pageTypes: "Page types",
      filterLogs: "Filter logs",
      all: "All",
      showAll: "Show all",
      showOnlyErrors: "Show only errors",
      onlyErrors: "Only errors",
      showOnlyWarnings: "Show only warnings",
      onlyWarnings: "Only warnings",
    },
    actions: {
      publish: "Publish",
      publishThisBuild: "Publish this build",
    },
    messages: {
      loadingLogs: "Loading the logs...",
    },
  },
  deploysView: {
    actions: {
      viewErrors: "View errors",
      viewBuild: "View build",
      viewFunctions: "View functions",
      visitBuild: "Visit build",
      viewBuildQueue: "View build queue",
    },
    headers: {
      deploysListTitle: "Deploy Previews for Feature Branches",
      pullRequestBuilds: "Pull Request Builds",
      mergeRequestBuilds: "Merge Request Builds",
      pullRequests: "Pull Requests",
      mergeRequests: "Merge Requests",
      productionBuildTitle: "Deploy Build for Production Branch",
      latestProductionBuild: "Latest Production Build",
      pullRequest: "Pull request: <strong>{title}</strong>",
      latestBuildForProductionBranch:
        "Latest build of the {productionBranch} branch",
      latestSuccessfulBuildForProductionBranch:
        "Latest successful deploy of the {productionBranch} branch",
      allBuildsOfBranch: "All the builds of the {productionBranch} branch",
      allBuildsOfPR:
        'All the builds of the pull request called "{pullRequestTitle}"',
      production: `Production`,
      publishBuild: `Publish build`,
      buildHistory: "Build history",
      lastPublishedBuild: "Last published build",
    },
    labels: {
      searchInputGithub:
        "Search deploy previews by pull request title or author",
      searchInputGitlab:
        "Search deploy previews by merge request title or author",
      searchInputPlaceholderGithub:
        "Start typing a pull request title or an author name",
      searchInputPlaceholderGitlab:
        "Start typing a merge request title or an author name",
      allBuilds: "All branch builds",
      buildDetails: "Build details",
      buildOfTitle: "A build of the {title} branch",
      history: "History",
      viewLatestBuildAt: "View latest build at",
      automaticDeploys: "Automatic deploys",
      viewProductionHistory: "View production history",
      publish: "Publish",
      disableAutomaticDeploys: "Disable automatic deploys",
    },
    messages: {
      buildTriggered: "Build triggered",
      deploysListSubtitleGithub:
        "Deploy previews are generated for this site when you open a pull request against the <strong>{productionBranch}</strong> branch.",
      deploysListSubtitleGitlab:
        "Deploy previews are generated for this site when you open a merge request against the <strong>{productionBranch}</strong> branch.",
      pullRequestBuilds:
        "Pull Request Builds are generated for this site when you open a pull request against the <strong>{productionBranch}</strong> branch.",
      mergeRequestBuilds:
        "Merge Request Builds are generated for this site when you open a merge request against the <strong>{productionBranch}</strong> branch.",
      noSearchResults: "No deploys found for this search request.",
      thisBuildWillGoLive: "This build will go live when you publish it.",
      latestSuccessfulBuildAlwaysAt: "Latest successful build always at",
    },
  },
  functionsView: {
    actions: {
      goBackToFunctions: "Functions",
      backToFunctionsList: "Back to functions list",
      seeRecentLogs: "See recent logs",
      readDocs: "Read the Functions docs",
    },
    headers: {
      functionLogsTitle: 'Logs for "{functionName}" function',
      noFunctions: "This site has no functions configured",
      noFunctionLogs: "There are no logs yet for this function",
      invocation: "Invocation",
      functionInvocationsLog: "Function invocations log",
      youDidntIncludeAnyFunctions:
        "You didn't include any functions in this build",
    },
    labels: {
      runSuccessfully: "Run successfully",
      failed: "Failed",
      timedOut: "Timed out",
      lastInvocationStatus: "Last invocation status",
      lastInvocationDate: "Last invocation date",
      functionDetailsShort: "View logs",
      functionDetails: "View logs for {functionName}",
    },
    messages: {
      noFunctionsDescription:
        "Learn more about configuring functions with Gatsby\u00A0Hosting <link>here</link>",
      noFunctionLogsDescription: "This function has not been run yet",
      noLogsforFuncion: "No logs for this function yet.",
      buildHasNoFunctions: "This build has no functions configured yet.",
      youCanDevelopTestAndDeploy:
        "You can develop, test, and deploy serverless functions alongside your frontend code.",
      thisFunctionhasNotBeenInvoked:
        "This function has not been invoked on this build for the last 12 hours.",
    },
  },
  buildsByBranchView: {
    headers: {
      noBuilds: "No builds",
      noBuildsYet: "No builds yet",
      listOfBuilds: "Builds of the <strong>{branch}</strong> branch",
    },
    labels: {
      backToSiteDetails: "Back to the site details",
    },
    messages: {
      loadingBuilds: "Loading the builds...",
      errorLoadingBuilds:
        "Something went wrong when fetching the builds: {error}",
      noBuildsForBranch: "There are actually no builds for this branch",
      noBuildsForPr: "There are actually no builds for this pull request",
      noBuildHistory: "Your build history will appear here.",
    },
  },
  setupSite: {
    pickBranch: "Branch to build from",
  },
  datocmsModal: {
    authorize: "Authorize with ",
    withDatoCms: "with DatoCMS",
    chooseProject: "Select a project to use as the data source for",
  },
  siteDetails: {
    actions: {
      addSiteDescription: "Click to add a description…",
      getStartedNow: "Get started now",
      setUpCustomDomain: "Set up a custom domain",
      installationInstructions: "Install Plugin",
    },
    labels: {
      sourceControlProviderChip: "Code hosted on {provider}",
      siteDirectory: "Base directory: {directoryPath}",
      functions: "Functions",
    },
    headers: {
      functions: "Functions",
      dataLayer: "Content Hub",
      production: "Production",
      pullRequests: "Pull Requests",
      settings: "Site Settings",
    },
    messages: {
      quicklyBoostYourWebPerf:
        "Quickly boost your web performance by hosting on Gatsby Cloud!",
      yourSiteIsHostedOnGatsbyCloud: "Your site is hosted on Gatsby Cloud!",
      legacyPreviewRequiredAction: `<strong>Action required:</strong> upgrade source plugins to maintain CMS Preview functionality.`,
    },
    builds: "Builds",
    previews: "CMS Preview",
    overview: "Overview",
    triggerRebuild: "Restart site",
    deploysFrom: "Deploys from",
    previewUrl: "Preview Url",
    previewStatus: "Preview Status",
    restart: "Restart",
    rebuild: "Rebuild",
    update: "Update",
    previousBuilds: "Previous updates",
    lastBuild: "Last update",
    logs: "Logs",
    showLogs: "Show logs",
    created: "Created",
    started: "Started",
    buildLogs: "Build logs",
    youCannotTrigger:
      "You cannot restart this site until the current update is finished.",
    authorize: "Authorize",
    siteHasNotAuthorized:
      "This site has not been authorized with our GitHub application",
    zeroBuildsTitle: "We're creating your site",
    zeroBuildsText:
      "This may take a few minutes. More information will be provided when the process has started.",
    branch: "BRANCH",
    view: "View",
    inModal: "in modal",
    inNewTab: "in new tab",
    experimentalFeatures: "Experimental features",
    incrementalBuilds: "Cloud builds",
    enabled: "Enabled",
    new: "New",
    deployTargets: "Deploy Targets",
    deploys: "Deploys",
    loadingBuilds: "loading builds...",
    loadingMoreBuilds: "loading more builds",
    buildsLoaded: "builds loaded",
  },
  previewTarget: {
    previewTarget: "Target Branch",
    editTarget: "Edit target",
    targetBranch: "Branch",
    directoryPath: "Directory path: ",
    cancel: "Cancel",
    save: "Save",
  },
  manageContributors: {
    actions: {
      confirm: "Confirm",
      transfer: "Transfer",
      transferOwnership: "Transfer ownership",
      manageMember: "Manage member {nameOrEmail}",
      removeMember: "Remove member",
      modifyMember: "Modify member",
      remove: "Remove",
      revokeInvite: "Revoke invite",
      resendInvite: "Resend invite",
    },
    headers: {
      removeMember: "Do you want to remove this member from the workspace?",
      removeMemberQuestion: "Remove member?",
      transferOrgQuestion: "Transfer workspace ownership?",
      revokeInvite: "Do you want to revoke the access of that user?",
      revokeInviteQuestion: "Revoke invite?",
      resendInvite: "Do you want to resend an invitation to that person?",
      resendInviteQuestion: "Resend invite?",
    },
    labels: {
      memberSiteAccessAll: "All sites",
      memberSiteAccessSome: "{count, plural, one {# site} other {# sites}}",
    },
    messages: {
      removeMemberConf:
        "Are you sure you want to remove <strong>{email}</strong>?",
      removeMemberEffects:
        "They will no longer be able to contribute to this workspace.",
      resendOrgInviteConf:
        "Are you sure you want to resend the invitation to collaborate on this workspace to <strong>{email}</strong>?",
      revokeOrgInviteConf:
        "Are you sure you want to revoke the invitation to collaborate on this workspace from <strong>{email}</strong>?",
      transferOwnership:
        "Do you want to transfer the ownership of this workspace?",
      transferOrg: "Transfer workspace ownership",
      transferOrgConf:
        "Are you sure you want to transfer workspace ownership to <strong>{email}</strong>?",
      transferOrgEffects:
        "You will no longer have access to owner permissions for this workspace",
      orgOwnershipTransferred: "Workspace ownership transferred successfully",
      memberRemoved: "Member removed successfully",
      memberInvitationResent: "Member invitation resent",
      memberInvitationRevoked: "Member invitation revoked",
    },
  },
  orgMembers: {
    actions: {
      addMembers: "Add Members",
      inviteMembers: "Invite Members",
    },
    labels: {
      docsLink:
        "View the documentation for details about roles and permissions",
      noPlan: "Upgrade my plan",
      searchMembers: "Search members",
    },
    headers: {
      noPlan:
        "You do not have access to invite more workspace members with the 'Free' plan",
      noViewPermissions: "You do not have permission to view workspace members",
    },
    messages: {
      loadingOrgMembers: "Loading your workspace members...",
      removeContributor:
        "Do you want to remove this contributor from the workspace?",
      viewingAndManagingSiteMembers: "Viewing and managing site members",
      comingSoon: "Coming soon",
      manageMembersInSettings:
        "This tab only shows workspace members at this time. The ability to manage site members in this tab is coming soon. For now, please continue using site settings to manage site members.",
      noViewPermissionsDescription:
        "Please contact your workspace owner to request permission.",
      noPlan: "Please upgrade your plan to invite members.",
    },
  },
  subscriptionStatus: {
    actions: {
      resubscribe: "Subscribe to Gatsby Cloud",
      updatePaymentInformation: "Update payment information",
    },
    messages: {
      loadingProvider: "Preparing the form…",
      errorLoadingProvider:
        "Something wrong occurred when trying to prepare the billing form. Please, refresh the page or retry the operation later.",
      paymentFailed: "Stopped: Payment with Visa ending in {lastFour} failed",
      paymentFailedDescription:
        "When trying to bill your Visa credit card we encountered the following error:",
      paymentFailedUpdate:
        "Please update your payment method by adding a valid credit card below.",
      trialExpired: "Your free trial period has expired.",
      planCanceled: "Canceled: Your plan was canceled on {cancellationDate}",
      paymentIsPastDue:
        "Your payment is past due. Please update your payment information to continue using Gatsby Cloud.",
      creditCardExpired: "Your credit card expired on {expirationDate}",
      creditCardExpiredUpdate:
        "Update payment information to continue using Gatsby Cloud",
      planChangeRequested:
        "Change to the <strong>{requestedPlanName}</strong> plan requested.\nPlease hold for our sales staff to contact you.",
    },
  },
  organizationStatus: {
    morphemes: {
      orgStatus: "Status",
    },
    headers: {
      statusSection: "Status",
      reactivate: "Reactivate idle workspace",
      reactivateQuestion: "Reactivate workspace?",
      orgInOverage: "Your workspace is currently in overage",
      orgIsIdle: "Your workspace is currently idle",
    },
    actions: {
      reactivateShort: "Reactivate",
      reactivate: "Reactivate this workspace",
      upgrade: "Upgrade this workspace",
    },
    messages: {
      orgIsIdle: "This workspace is currently idle",
      orgInOverage:
        "This workspace has reached its limit of monthly real-time edits",
      reactivated: "<strong>{organizationName}</strong> reactivated",
      idleStatusScreen:
        "Due to inactivity your workspace is in idle mode. Visit your workspace settings to reactivate anytime.",
      idleStatusInfo:
        "Shh! Your workspace is sleeping. We put it in idle mode because you haven't made any builds in over a month. Reactivate to wake it up again.",
      activeStatusInfo:
        "Your workspace is currently active. If you've haven't made any builds for over a month we may put it in idle mode, but you can always wake it up again!",
      overageStatusInfo:
        "Your workspace has reached its limit of monthly real-time edits, and is currently in overage mode. To increase your limit, consider upgrading your plan.",
    },
  },
  organizationPlan: {
    labels: {
      currentPlanName: "Current plan: {planName}",
      triallingPlan: "{planName} Trial",
    },
  },
  envVars: {
    actions: {
      copyAllVars: " Bulk Copy Variables",
      addVariableRow: "Add Variable",
      addBulkVariables: "Bulk Add Variables",
      removeVariableRow: "Remove environment variable",
      removeVariableRowShort: "Remove",
      editVariables: "Edit Variables",
      bulkSubmit: "Add",
    },
    headers: {
      environmentVariables: "Environment variables",
      noEnvVars: "No environment variables",
      bulkAdd: "Add environment variables",
      setVars: "Set Environment Variables",
    },
    labels: {
      helpLink: "Learn more about managing environment variables",
      buildVariablesTab: "Build variables",
      previewVariablesTab: "Preview variables",
      keyFieldPlaceholder: "Key",
      valueFieldPlaceholder: "Value",
      keyFieldLabel: "Environment variable key",
      valueFieldLabel: "Environment variable value",
      bulkAddModal: "Add multiple environment variables at once",
      bulkAddPlaceholder: "Add environment variables",
      bulkAdd: "Add multiple environment variables at once",
    },
    messages: {
      copiedToClipBoard: "Copied to clipboard!",
      loadingEnvVars: "Loading environment variables for your site...",
      noEnvVarsDescription:
        "There are no {envVarsOfType} set up for this site.",
      noEnvVarsTypeBuild: "build environment variables",
      noEnvVarsTypePreview: "preview environment variables",
      bulkAddValidateRequired:
        "You must enter at least one environment variable",
      bulkAddValidateFormatShort: "Looks like some of your input is invalid.",
      bulkAddValidateFormat:
        "Looks like some of your input is invalid. Check that the following environment variables are correctly formatted: {invalidEnvVars}.",
      bulkAddFormat: "Add each variable on a new line in the format: VAR=value",
      checkingConfigFile:
        "Detecting environment variables you may want to add based on your <span>{configFile}</span>",
    },
  },
  buildStates: {
    running: "running",
    rebooting: "rebooting",
  },
  provisionLogs: {
    headers: {
      noRawLogs: "No logs Found",
    },
  },
  buildLogs: {
    headers: {
      previewLogs: "Preview logs",
      noRawLogs: "No logs found",
      noLogsFound: "No logs found",
    },
  },
  members: {
    morphemes: {
      viewer: "Viewer",
      editor: "Editor",
      owner: "Owner",
      admin: "Admin",
    },
  },
  addMembers: {
    actions: {
      addMember: "Add Member",
      removeMember: "Remove",
      sendInvites: "Send invites",
    },
    headers: {
      addMembersTitle: "Add Members",
      inviteMembers: "Invite Members",
      memberFieldsGroup: "Member {num}",
    },
    messages: {
      addMembersDescription:
        "Enter emails of people you would like to invite. Invited users will receive an email in their inbox inviting them to this workspace.",
      memberInvitationSent:
        "<strong>Member invitation sent</strong> successfully",
    },
  },
  modifyMember: {
    actions: {
      modifyMember: "Modify Member",
      saveChanges: "Save changes",
    },
    headers: { modifyMemberTitle: "Modify Member" },
    messages: {
      modifyMemberDescription:
        "Modifying the roles and permissions for {name}.",
      memberModifyConfirmation: "<strong>Member modified</strong> successfully",
    },
  },
  memberFields: {
    labels: {
      email: "Email address",
      role: "Role",
      siteAccess: "Site access",
      allowAllSitesAccess: "Access to all sites",
      allowSomeSitesAccess: "Access to some sites only",
      pickSites: "Select sites",
    },
    messages: {
      roleHintViewer: "Can view sites only. Cannot create or modify sites.",
      roleHintEditor: "Can create, view, and modify sites.",
      roleHintOwner:
        "Access to all sites in a space. Can create, view, and modify sites, workspaces, and plan & billing information.",
      roleHintAdmin:
        "Access to all sites in a space. Can invite members. Can create, view, and modify sites and workspaces.",
      ownerSiteAccessDisclaimer:
        "Owners get access to all sites within the workspace. To set specific site access, change the role.",
      sitesSelectedAll:
        "All current sites in the workspace are selected. This member will not automatically have access to any new sites created in the workspace.",
      sitesSelectedNone: "None selected",
      sitesSelectedNum:
        "{count, plural, one {# site} other {# sites}} selected",
      validationEmailNotAMember:
        "This user has already been invited to the workspace.",
      validationEmailUnique: "Emails must be unique.",
      validationSitesRequired: "Please select at least one site to continue.",
    },
  },
  billing: {
    addPayment: "Add a payment method",
    creditCardInformation: "Credit card information",
    name: "Name on card",
    cardNumber: "Card number",
    expirationDate: "Expiration date",
    cvcCode: "CVC code",
    optionalInformation: "Optional information",
    companyName: "Company name",
    requiredField: "This field is required",
    validEmail: "Please enter a valid email address",
    cancel: "Cancel",
    startSubscription: "Start subscription",
    subscriptionNote: 'By clicking "Start subscription", you agree with our ',
    termsAndConditions: " Terms and Conditions",
    yourOrder: "Your order",
    gatsbyPreview: "Gatsby Preview",
    total: "Total",
    paymentDetails: "Payment Details",
    updatePaymentDetails: "Update Payment Details",
    billed: "Billed",
    billedDetails: "via debit/credit card.",
    updatePayment: "Update payment information",
    contactSupport: "Contact Support",
    gotIt: "Got it!",
    plan: "Plan.",
    month: "month",
    year: "year",
    monthYear: "month / year",
    formEmail: "Email address",
    company: "Company name",
    changePlanFor: "Change plan for",
    morphemes: {
      month: "month",
    },
    headers: {
      billingAddress: "Billing address",
      billingInterval: "Billing interval",
    },
    labels: {
      billingAddress: "Billing address",
      billingAddressLineTwo: "Apartment, Suite, etc",
      billingCity: "City",
      billingState: "State",
      billingZipCode: "Zip Code",
      billingCountry: "Country",
      selectCountry: "Select country",
      billingInterval: "Billing interval",
      billingIntervalOptionMonthly: "Monthly",
      billingIntervalOptionAnnual: "Yearly",
      monthly: "Monthly",
      yearly: "Yearly",
      save15: "(save 15%)",
      mostPopular: "Most popular",
      current: "Current",
      trial: "(Trial)",
    },
    messages: {
      contactSalesForCustomPlan:
        "Don't see a plan that fits your needs? We're here to help. Contact <link>sales@gatsbyjs.com</link> for a customized plan built for you.",
      fourteenDaysfreeTrial: "14-day free trial",
      save15withyearlyBilling: " Save 15% with yearly billing",
    },
  },
  changePlanRequest: {
    headers: {},
    cancel: "Cancel",
    submit: "Submit request",
    Enterprise: {
      heading: "It's time for us to roll out the red carpet!",
      lede: "We're here to personalize a solution to meet your exact needs. Let's chat through how we can best equip your team to succeed on our Cloud Enterprise plan.",
      note: "We'll get in touch with you as soon as possible. If there is a preferred time to do so, please let us know.",
    },
    Agency: {
      heading: "Look at you grow!",
      lede: "Congratulations on your continued success! We're here to help you in the next stage of your Gatsby journey as you scale your client relationships. Let's hop on a call to ensure you're set up for success on our Agency plan.",
      note: "We'll get in touch with you as soon as possible. If there is a preferred time to do so, please let us know.",
    },
    Business: {
      heading: "Change to Business",
      lede: "Thanks for your interest in Gatsby Cloud Business! We want to create the best solution for your team, and believe that having a conversation is the best way to do so.",
      note: "We'll get in touch with you as soon as possible. If there is a preferred time to do so, please let us know.",
    },
    Free: {
      heading: "Cancel Plan",
      lede: "Cancel your billing subscription.",
      note: "We're sorry to see you go! Your subscription will cancel at the end of your current billing period.",
    },
    default: {
      heading: "Change to",
      lede: "Your plan change request will be processed immediately.",
    },
  },
  planInformation: {
    morphemes: {
      tier1PlanName: "Free",
      tier2PlanName: "Individual",
      tier3PlanName: "Team",
      tier4PlanName: "Enterprise",
      freePlanName: "Free",
      standardPlanName: "Standard",
      performancePlanName: "Performance",
      professionalPlanName: "Professional",
      agencyPlanName: "Agency",
      enterprisePlanName: "Enterprise",
    },
    headers: {
      currentPlan: "Current Plan",
      planFeatureCategoryFeature: "Features",
      planFeatureCategoryCollaboration: "Collaboration",
      planFeatureCategoryLogin: "Log in with...",
      planFeatureCategoryProviders: "Git Providers",
      planFeatureCategoryDeploy: "Deploy to...",
      addOns: "Add-ons",
      yourTrialHasEnded: "Your 14-day free trial has ended",
    },
    actions: {
      pickTier1: "Get started for free",
      pickTier2: "Start 14-day free trial",
      pickTier2Aria: "Start 14-day free trial of Individual plan",
      pickTier3: "Start 14-day free trial",
      pickTier3Aria: "Start 14-day free trial of Team plan",
      pickTier4: "Contact Sales",
      changePlan: "Change plan",
      editAddOns: "Edit add-ons",
      pickFreeTier: "Get started",
      pickProfessionalTier: "Try for free today",
      pickAgencyTier: "Improve your Agency workflow",
      getStarted: "Get started",
      tryForFreeToday: "Try for free today",
      contactSales: "Contact Sales",
    },
    messages: {
      defaultFeaturesIntro:
        "Everything in <strong>{prevTierPlanName}</strong>, plus:",
      tier1PlanDescription:
        "For <strong>personal</strong> and single purpose sites",
      tier1PlanFeatures: [
        "100 Real-Time Edits/month",
        "Standard Builds",
        "Deploy Previews",
        "Real-time CMS Previews",
        "Lighthouse Reports",
        "1 editor",
      ],
      tier2PlanDescription:
        "For <strong>pro developers</strong> building pilot projects or small sites",
      tier2PlanFeatures: [
        "250 Real-Time Edits/month",
        "Cloud builds",
        "Deploy Previews",
        "Real-time CMS Previews",
        "Site Access Control",
        "Lighthouse Reports",
        "1 editor",
      ],
      tier3PlanDescription:
        "For <strong>organization-wide</strong> use and teams producing large sites",
      tier3PlanFeatures: [
        "1000 Real-Time Edits/month",
        "Cloud builds",
        "Deploy Previews",
        "Real-time CMS Previews",
        "Site Access Control",
        "Lighthouse Reports",
        "5 editors",
      ],
      tier4PlanDescription:
        "<strong>Custom packages</strong> designed for the needs of your company",
      tier4PlanFeatures: [
        "Dedicated Slack Channel",
        "New Team Training",
        "Site Optimization Consultation",
        "Custom Number of Editors",
      ],
      monthlyAmountAria: "${amount} per month",
      trialNoCardRequiredHint:
        "No credit card required. After the {trialDays} days, you will automatically be downgraded to the {planName} Plan.",
      custom: "Custom",
      byQuote: "By quote",
      featureComparisonSummary:
        "A comparison of features available in the different Gatsby Cloud plans.",
      planFeatureRte: "Real-time edits",
      planFeatureContentPreviews: "CMS Previews",
      planFeatureDeployPreviews: "Deploy Previews",
      planFeatureLighthouseReports: "Lighthouse Reports",
      planFeatureIncrementalBuilds: "Cloud builds",
      planFeatureConcurrentBuilds: "Concurrent Builds",
      planFeatureSupportSLA: "Support SLA",
      planFeatureEditors: "Editors",
      planFeatureViewers: "Viewers (coming soon)",
      planFeaturePrivateUrls: "Site Access Control",
      planFeatureCustomUrls: "Custom URLs (coming soon)",
      planFeatureEnforceSSO: "Enforce Single Sign-On",
      planFeatureGithub: "GitHub",
      planFeatureGitlab: "GitLab",
      planFeatureBitbucket: "Bitbucket (coming soon)",
      planFeatureGoogle: "Google (coming soon)",
      planFeatureGithubEnterprise: "GitHub Enterprise (coming soon)",
      planFeatureGitlabEnterprise: "GitLab Enterprise (coming soon)",
      planFeatureCloudflare: "Cloudflare",
      planFeatureNetlify: "Netlify",
      planFeatureFastly: "Fastly",
      planFeatureFirebase: "Firebase",
      planFeatureAws: "AWS S3",
      planFeatureGoogleStorage: "Google Storage",
      planFeatureZeit: "Vercel",
      planFeatureAzure: "Azure",
      planRteIntervalsFree: "100 / month",
      planRteIntervalsTeam: "250 / month",
      planRteIntervalsEnterprise: "1000 / month",
      settingsTrialEndInformation:
        "After your {trialPlanName} plan trial ends, you will automatically be converted to the {freePlanName} plan. You can <link>upgrade anytime</link> to use features found in our {trialPlanName}+ plans.",
      changePlanTrialEndInformation:
        "You will automatically be switched to the {freePlanName} plan at the end of your trial if you choose not to upgrade.",
      upgradeNowToKeepEnjoying:
        "Upgrade now to keep enjoying the <strong>{plan}</strong> plan benefits. You'll be directed to the pricing page to complete your purchase.",
    },
    labels: {
      linkToPricingDocs: "Plan information docs",
      continueToPayment: "Continue to payment",
      noThanksContinueFree: "No thanks, I'll continue with the Free plan",
    },
  },
  orgDetails: {
    actions: {
      backToWorkspace: "Go to workspace",
    },
    labels: {
      settings: "Settings",
      workspaceSettings: "Workspace Settings",
      sites: "Sites",
      members: "Members",
    },
    headers: {
      noAccessTitle:
        "You do not have permissions to view this workspace settings",
    },
    messages: {
      noAccessDescription:
        "Please contact your workspace owner to request permission.",
    },
  },
  orgSettings: {
    headers: {
      general: "General",
      details: "Workspace Details",
      status: "Status",
      plan: "Plan",
      usage: "Usage",
      addons: "Add-ons",
      paymentMethod: "Payment method",
      paymentHistory: "Payment history",
      selfHostedGit: "Self-Hosted Git",
      vcsHealth: "Git provider authentication status",
    },
  },
  selfHostedGitConnection: {
    actions: {
      saveConnection: "Save Connection",
      disableConnection: "Disable",
      deleteConnection: "Delete",
      cancel: "Cancel",
    },
    headers: {
      settings: "Self-Hosted Git Connections",
      modal: "Connect to GitHub Enterprise Server",
      gitlabModal: "Connect to GitLab Self Managed Server",
      createApp: "1. Create your custom GitHub app",
      connectApp: "2. Connect your custom GitHub app to Gatsby Cloud",
      createGitlabApp:
        "1. Create an OAuth application on your GitLab Self Managed Server",
      connectGitlabApp:
        "2. Connect your custom GitLab Self Managed Server to Gatsby Cloud",
    },
    labels: {
      webhookUrl: "Webhook URL",
      callbackUrl: "Callback URL",
      setupUrl: "Setup URL",
      instanceUrl: "Instance URL",
      appId: "App ID",
      clientID: "Client ID",
      clientSecret: "Client Secret",
      privateKey: "Private Key",
      webhookSecret: "Webhook Secret",
      displayName: "Display Name",
    },
    messages: {
      settingsDescription:
        "Connect your Workspace to your self-hosted Git instance and source Gatsby Cloud sites from its repositories.",
      instructions:
        "To connect your Gatsby Cloud team to GitHub Enterprise Server, you will need to create a custom GitHub app on your self-hosted instance and then provide us the details about your instance/app.",
      instructionsLink: "Visit our docs for step-by-step instructions",
      createApp: "To create your custom GitHub app, you'll need these values.",
      createGitlabApp:
        "To create your custom GitLab OAuth app, you'll need this value.",
      connectApp:
        "After creating your custom GitHub app, fill out the following form to set up its integration with Gatsby Cloud and your workspace:",

      validatingConnection: "Validating connection...",
      connectGitlabApp:
        "After creating your custom OAuth app, fill out the following form to set up its integration with Gatsby Cloud and your workspace:",
      featureDescription:
        "You can add new Gatsby Cloud sites from your self-hosted Git server's repositories using the Add site button in your Workspace's Sites section. If you have connected to other Git providers before, click Switch provider in Add site to select your self-hosted Git provider.",
      statusConnected: "Connected",
      statusDisabled: "Disabled",
      deleteGitConnectionConf: "Are you sure you want to delete ",
      deletedSuccessfully: "deleted successfully",
      loseConnectionDescription:
        "You will no longer be able to import new sites or build existing sites from this Git server.",
      yesDeleteConnection: "Yes, delete this connection",
    },
  },
  paymentInformation: {
    paymentInformation: "Payment information",
    updatePayment: "Update payment method",
    updatePaymentFor: "Update payment method for",
    paymentNoPermissions:
      "You do not have permissions to view payment information. Please contact the workspace owner.",
    paymentMethodUpdated: "Payment method updated ",
    successfully: "successfully!",
    addPaymentMethod: "Yes, add new payment method",
    cancel: "No, cancel",
    cancelText: "Cancel",
    resubscribe: "Resubscribe",
    resubscribeToManage:
      "Your subscription was canceled. To manage your workspace and sites you'll need to reactivate your subscription.",
    ownerMustResubscribe:
      "The subscription for this workspace has been canceled. The workspace owner must resubscribe to resume managing this workspace and associated sites",
    updatedSuccessfully: "updated successfully",
    actions: {
      updatePayment: "Update payment method",
    },
    labels: {
      cardNumber: "Card number",
      billingInterval: "Billing interval",
      nextPayment: "Next payment",
    },
    headers: {
      paymentInformation: "Payment Information",
      paymentHistory: "Payment History",
    },
    messages: {
      billedMonthly: "Billed monthly",
      billedAnnually: "Billed annually",
      nextPaymentReceived: "Next payment received",
    },
  },
  paymentHistory: {
    messages: {
      viewYourPaymentHistory:
        "You can view your payment history, download invoices, and update billing address and information using our portal below.",
    },
    actions: {
      goToPortal: "Go to the Portal",
      visitPortal: "Visit portal",
    },
  },
  notFound: {
    actions: {
      goToHomepage: "Back to homepage",
    },
    headers: {
      pageNotFound: "Page not found",
    },
    messages: {
      pageNotFoundIntro:
        "Sorry 😔 — we couldn't find what you were looking for.",
      needHelp: "Need help finding something?",
      contactSupport:
        "Email <link>support@gatsbyjs.com</link> and we'll help you.",
    },
  },
  webhookCard: {
    webhookIntegration: "Webhook Integration",
    sendPostRequest:
      "Please send a POST request to this webhook URL whenever data is updated, so that these changes can be pushed to Gatsby Preview",
    previewWebhook: "Preview webhook",
    buildsWebhook: "Builds webhook",
  },
  branchList: {
    actions: {
      showOptions: "Show available options",
    },
    messages: {
      zeroResults: "No results",
    },
    labels: {
      searchPlaceholder: "Find a branch...",
    },
  },
  visitorAccess: {
    public: "Public",
    anyoneCanVisit:
      "Anyone can view your site's Preview-specific and Build-specific URLs.",
    passwordProtected: "Password protected",
    ipRangeProtected: "IP range protected",
    visitorHasToKnowPassword:
      "Password required to view your site's Preview-specific and Build-specific URLs.",
    logInRequired: "Log in required",
    visitorMustHaveGatsbyAccount:
      "Gatsby Cloud account required to view your site's Preview-specific and Build-specific URLs.",
    visitorMustHaveIp:
      "Proper IP required to view your site's Preview-specific and Build-specific URLs.",
    cantBeEmpty: "Can't be empty",
    editAccess: "Edit",
    setPassword: "Set Password",
    cancel: "Cancel",
    save: "Save",
    visitorAccess: "Access control",
    updated: "updated",
    editVisitorAccess: "Edit Visitor Access",
    show: "Show",
    hide: "Hide",
  },
  previewLogin: {
    actions: {
      viewSite: "View site",
    },
    labels: {
      gatsbyPreviewLink: "Gatsby Preview",
      documentationLink: "Documentation",
      passwordField: "Password",
    },
    headers: {
      cloudAuthForm: "Please identify yourself to view this site",
      passwordAuthForm: "This site is password protected",
    },
    messages: {
      noPermission: "You do not have permissions to view this Preview",
      verificationFailed: "Failed to verify password",
    },
  },
  newLeadCapture: {
    headers: {
      welcomeFreeTier: "Get started with Gatsby Cloud",
      welcomeTrial: "Get Building Faster",
      whatsIncludedFreeTier:
        "Build, preview, deploy, and scale your site in just a few easy steps.",
      whatsIncludedTrial: "What's included in the trial?",
    },
    messages: {
      trialEndDisclaimer:
        "No credit card required. After the {trialDays} days, you will automatically be downgraded to the <strong>{freeTierPlanName} plan.</strong>",
      trialingPlanFeatures: "All {trialingPlanName} features including:",
      trialFreeFeatures:
        "We will automatically switch you to the {freePlanName} Plan, which includes:",
      getStartedMessage:
        "Sign up for your free account and start building and hosting your project today.",
      noCreditCardRequired:
        "<small> Start your {trialDays}-day trial of Gatsby Cloud</small> <small>No credit card required.</small>",
    },
    labels: {
      firstName: "First name",
      lastName: "Last name",
      workEmail: "Work email",
      country: "Country",
      region: "State/Province",
      projectType: "I want to use Gatsby for...",
      projectTypeCompany: "Company Project",
      projectTypeClient: "Client Project",
      projectTypePersonal: "Personal Project",
    },
    actions: {
      submit: "Start building",
      proceedFreeTier: "Next",
      proceedTrial: "Start my free trial",
    },
  },
  leadCapture: {
    headers: {
      heyThere: "Hey there!",
      trialInfo:
        "You're getting access to a Gatsby Cloud <strong>{trialDays}-day {trialingPlanName} Trial</strong>",
      trialFeatures: "What does my free trial include?",
      trialEnd: "What happens after {trialDays} days?",
      welcomeFreeTier: "Get started with Gatsby Cloud",
      welcomeTrial:
        "Start your {trialDays}-day <strong>{trialingPlanName}</strong> trial",
      whatsIncludedFreeTier:
        "Build, preview, deploy, and scale your site in just a few easy steps.",
      whatsIncludedTrial: "What's included in the trial?",
    },
    messages: {
      intro:
        "Before you continue, tell us about yourself! This will help us make Gatsby Cloud better for you.",
      trialEndDisclaimer:
        "No credit card required. After the {trialDays} days, you will automatically be downgraded to the <strong>{freeTierPlanName} plan.</strong>",
      trialingPlanFeatures: "All {trialingPlanName} features including:",
      trialFreeFeatures:
        "We will automatically switch you to the {freePlanName} Plan, which includes:",
      noCreditCardRequired: "No credit card required.",
    },
    labels: {
      firstName: "First name",
      lastName: "Last name",
      workEmail: "Work email",
      country: "Country",
      region: "State/Province",
      projectType: "I want to use Gatsby for...",
      iAmUsingGatsbyFor: "I'm using Gatsby for a:",
      projectTypeCompany: "Company Project",
      projectTypeClient: "Client Project",
      projectTypePersonal: "Personal Project",
    },
    actions: {
      submit: "Start building",
      proceedFreeTier: "Next",
      proceedTrial: "Start my free trial",
    },
  },
  upgrade: {
    headers: {
      upgradeToFreeTrial:
        "Would you like to upgrade to a <strong>{trialDays}-Day Free Trial?</strong>",
      upgradeDetails:
        "No credit card required. After the {trialDays} days you will automatically be downgraded to the <strong>Free Plan</strong>.",
    },
    messages: {
      automaticDowngrade:
        "No credit card required. After 14 days, you will automatically be downgraded to the <strong>Free Plan</strong>.",
    },
    actions: {
      pickTier1Trial: "No, continue with Free Plan",
      pickTier2Trial: "Yes, start Individual Trial",
      pickTier3Trial: "Yes, start Team Trial",
    },
  },
  deleteCDN: {
    actions: {
      delete: "Delete Integration",
    },
    headers: {
      deleteIntegration: "Delete Integration?",
    },
    messages: {
      areYouSure:
        "Are you sure you want to delete the <strong>{cdnVendorName} integration</strong> for <strong>{siteName}</strong>? Gatsby Cloud will stop triggering deploys for this site.",
      cdnIntegrationRemoved: "{cdnVendorName} integration removed successfully",
    },
  },
  publishReports: {
    addReport: "Add report",
    save: "Save",
    cancel: "Cancel",
    noPluginsYet: "You have not plug any build report in yet.",
    publishReports: "Reports",
  },
  userSettings: {
    orgsAndBilling: "Workspaces & Billing",
    followTheLink:
      "Follow the link to manage billing and members of workspaces that you own or admin.",
    personalDetails: "Personal Details",
    saveButton: "Save all changes",
    joined: "Joined",
    owns: "Owns",
    created: "Created",
    site: "site",
    noOrgsNote: "You are not part of any workspaces yet.",
    errorFetchingOrgs:
      "Oops. There was an error retrieving your workspaces. If the error persists, please email support at support@gatsbyjs.com.",
    yourAccount: "Your Account",
    accountOverview: "Overview",
    headers: {
      updateYourPersonalDetails: `Update your personal details`,
    },
    messages: {
      yourNameAndEmailHelpUs: `Your name and email address help us follow up on support tickets, inform you of maintenance or outages, and keep you up-to-date on events, research opportunities, and feature releases.`,
    },
    actions: {
      updateYourDetails: `Update your details`,
    },
  },
  maintenance: {
    headers: {
      maintenanceHeader: "Sorry, Gatsby is down for maintenance",
    },
    messages: {
      maintenanceDescription: "We will be back up shortly",
    },
  },
  previewStatus: {
    labels: {
      previewStopped:
        "Previews have stopped because your workspace is in idle mode.",
    },
  },
  buildStatus: {
    labels: {
      organizationActive: "Workspace is out of Overage period",
    },
  },
  importSiteNew: {
    headers: {
      cmsIntegrationsStep:
        "Detecting installed integrations in your site's <span>gatsby-config.js</span>",
    },
    labels: {
      siteNameField: "Site name",
      baseBranchField: "Production branch",
      baseDirectoryField: "Gatsby root folder",
    },
  },
  importSite: {
    actions: {
      cmsIntegrationsSkip: "Skip this step",
      cmsIntegrationsNext: "Set up your site",
      seeMoreCmsIntegrations: "See more integrations",
      chooseSourceProvider: "Use {sourceProvider}",
      publishSite: "Create site",
      refreshList: "Refresh the list",
      import: "Import",
    },
    headers: {
      repositoryStepGitHub:
        "Select a <strong>GitHub organization and repository</strong>",
      repositoryStepGitLab:
        "Select a <strong>GitLab group and repository</strong>",
      repositoryStepBitbucket:
        "Select a <strong>Bitbucket workspace and repository</strong>",
      repositorySiteDetails: "Site Details",
      cmsIntegrationsStep:
        "Set up integrations for <strong>{siteName}</strong>",
      cmsIntegrations: "Integrations",
      cmsOtherIntegrations: "Other integrations",
      cmsSuggestedIntegrations: "Suggested integrations",
      sourceProviderStep: "Select a Git provider",
      setupSiteStep: "Set up site for <strong>{repoName}</strong>",
      selectedBranch: "Branch to build from",
    },
    labels: {
      sourceProviderStep: "Git provider",
      repositoryStep: "Repository",
      integrationsStep: "Integrations",
      setupStep: "Setup",
      sourceProviderTeamFieldGitHub: "Select an Organization",
      sourceProviderTeamFieldGitLab: "Select a Group",
      sourceProviderTeamFieldBitbucket: "Select a Workspace",
      repositoryField: "Select a Repository",
      baseBranchField: "Base Branch",
      baseDirectoryField: "Base Directory",
      siteNameField: "Site Name",
      searchRepositories: "Search repositories",
    },
    messages: {
      loadingSourceProviderTeams: "Loading your repositories...",
      loadingRepositoryBranches: "Loading your repo branches…",
      refreshingSourceProviderTeams: "Refreshing the list...",
      baseDirectoryHint: "The default is set to the root directory",
      creatingSite: "Creating your site...",
      loadingIntegrations: "Loading available cms integrations...",
      cmsIntegrationsIntro:
        "We detected integrations in your site's configuration — connect them now to automatically configure environment variables and enable Gatsby Preview.",
      cmsIntegrationsDocsInfo:
        "Not ready yet? That's ok! You can add multiple data sources at any time through the site settings. <link>Read more about integrations</link>",
      sourceProviderIntro:
        "Import your site to Cloud by selecting the Git provider where your code is stored.",
      loadingDataForSetup: "Loading site data...",
      setupLater:
        'Need help with environment variables of webhook setup? Go to "{integrationsStep}" step now or setup integrations later in your site settings.',
      noRepositoryWithThatName: "There is no a repository with that name.",
      fieldIsRequiredSelectRepository:
        "The field is required, select a repository.",
      noRepos: "No repositories found",
      justAddedRepo: "Just added your repository?",
    },
  },
  deployNow: {
    labels: {
      repositoryStep: "Repository",
      integrationsStep: "Integrations",
      setupStep: "Setup",
      configureRepository: "Configure your new repository",
      whichWorkspace: "Which workspace do you want to create the project in?",
      repoName: "What is the new repository name?",
    },
    messages: {
      creatingRepository: "Creating repository...",
      cloningRepo: "Cloning repository...",
      pushingRepository: "Pushing repository...",
      creatingSite: "Creating site...",
      success: "Success!",
      addIt: "Add it",
      openWindowGithubAuthentication:
        "We just opened a new browser window to authenticate with GitHub. Accidentally closed the window?",
      waitAMoment:
        "Thank you. Please wait a few moments while we load your GitHub information.",
      provisioningInProgress: "Provisioning CMS data...",
      installingDependencies: "Installing repo dependencies...",
      runningScript: "Running provisioning script...",
      provisioningFailed: "Something went wrong :(",
    },
    headers: {
      provisionScriptStep:
        "We found a <span>gatsby-provision</span> npm script that will provide data for the following CMS:",
    },
    actions: {
      provisionData: "Provision data",
    },
  },
  ui: {
    actions: {
      back: "Back",
      cancel: "Cancel",
      gotIt: "Got it",
      next: "Next",
      save: "Save",
      edit: "Edit",
      remove: "Remove",
      continue: "Continue",
      turnOn: "Turn on",
      turnOff: "Turn off",
      yesTurnOff: "Yes, Turn off",
      returnToHomepage: "Back to homepage",
      editSettings: "Edit settings",
    },
    labels: {
      removing: "Removing",
      updating: "Updating",
      disabled: "Disabled",
      enabled: "Enabled",
      beta: `Beta`,
    },
    messages: {
      graphqlError: "Error: {errorText}",
      validationCantBeEmpty: "Can't be empty",
      validationIsRequired: "This field is required",
      validationInvalidEmail: "Invalid email",
      internalServerError: "Internal server error",
      saving: "Saving",
    },
  },
  enterpriseConnectionForm: {
    messages: {
      validationUrl: `Must be a valid URL`,
      validationInvalidUrl: `A URL starting with https:// is required.`,
      privateKeyRequired: `A private key is required.`,
      privateKeyStart: `Private key must start with -----BEGIN RSA PRIVATE KEY-----`,
      privateKeyEnd: `Private key must end with -----END RSA PRIVATE KEY-----`,
      validationIsRequired: `This field is required.`,
      genericErrorOnSave: `We encountered an error saving your credentials. Please try again.`,
    },
  },
  releaseNotes: {
    headers: {
      title: "Latest Releases & Updates for Gatsby Cloud",
      emptyState: "There are no release notes for now.",
    },
    messages: {
      stayTuned:
        "This page will list all the new features, bugfixes and maintenances occurring on Gatsby Cloud.",
    },
    actions: {
      viewDetails: "View details",
    },
    labels: {
      newFeature: "New feature",
      maintenance: "Maintenance",
      bugfix: "Bug fix",
    },
  },
  announcementWorkspaces: {
    headers: {
      title: "New feature announcement",
      featureTitle: "Introducing Gatsby\u00A0Cloud\u00A0Workspaces",
    },
    messages: {
      catchPhrase:
        "We're excited to share an update that makes Gatsby Cloud even easier to use. Here's a quick summary of the most important changes that you'll see when you log in today:",
      features: [
        "Organizations are now known as Workspaces",
        "New sites can be added to a Workspace from any repository or organization in GitHub",
        "You can create new Workspaces with separate subscriptions, giving you the flexibility to organize your sites to match your needs",
      ],
    },
    actions: {
      viewWorkspaces: "Go to workspaces",
      goToReleaseNotes: "See all release notes",
      seeReleaseNotes: "See release notes",
      openNewAnnouncement: "See the new announcements",
    },
  },
  cdnIntegration: {
    morphemes: {
      netlifySite: "Site",
      netlifyAccount: "Account",
      fastlyService: "Service",
      firebaseProject: "Project",
      firebaseSite: "Site",
      amazonS3Bucket: "Bucket",
      gcloudStorageBucket: "Bucket",
      vercelProject: "Project",
      vercelTeam: "Team",
      azureStorageAccount: "Storage Account Name",
    },
    actions: {
      connectShort: "Connect",
      connectCdn: "Connect {cdnName}",
      manageCdn: "Manage {cdnName} integration",
    },
    headers: {
      amazonS3IntegrationTitle: "AWS S3 Integration",
      azureIntegrationTitle: "Azure Integration",
      fastlyIntegrationTitle: "Fastly Integration",
      firebaseIntegrationTitle: "Firebase Integration",
      gcloudStorageIntegrationTitle: "Google Cloud Storage Integration",
      netlifyIntegrationTitle: "Netlify Integration",
      vercelIntegrationTitle: "Vercel Integration",
      authorizeCdn:
        "Do you authorize your Gatsby Cloud site to integrate with {cdnVendorName}?",
    },
    messages: {
      cdnIntegrationUpdated: "CDN configuration updated",
      vendorNotSupported:
        "{cdnVendorName} integration does not seem to be supported",
    },
    labels: {
      siteDeploysTo: "Deploys to {cdnVendorName}",
    },
  },
  logDrainIntegration: {
    morphemes: {
      region: `Region`,
      apiKey: `API key`,
    },
    headers: {
      dataDog: `Datadog`,
      providerLogDrains: `{logDrainProviderName} log drains`,
      deleteIntegration: "Delete Integration?",
      logDrains: "Log drains",
    },
    actions: {
      connect: "Connect",
      connectProvider: "Connect {logDrainProvider}",
      manageCdn: "Manage {logDrainProvider} integration",
      delete: "Delete Integration",
    },
    messages: {
      areYouSure:
        "Are you sure you want to delete the <strong>{logDrainProvider} integration</strong> for <strong>{siteName}</strong>?",
      logDrainIntegrationRemoved:
        "{logDrainProvider} integration removed successfully",
      neverDrained: `Never drained`,
      lastDrainedAt: `Last drained {lastDrainedAt}`,
    },
  },
  dataDogIntegrationConfig: {
    messages: {
      introText: `Currently, you can only sync hosting logs.`,
      created: `Datadog Log Drain Connected!`,
      updated: `Datadog Log Drain Updated!`,
    },
    actions: {
      connect: "Connect",
      cancel: "Cancel",
      update: "Update",
    },
    labels: {
      region: "Region",
      baseURL: "Base URL",
      ApiKey: "API key from your Datadog account",
    },
  },
  netlifyIntegrationConfig: {
    actions: {
      connect: "Connect",
      create: "Create",
      switchToExistingSite:
        "Click here to connect to an existing Netlify deployment site",
      switchToNewSite: "Click here to connect to a new Netlify deployment site",
    },
    headers: {
      connectToSite: "Connect Netlify to <strong>{siteName}</strong>",
      connectToExisting: "Connect to an existing Netlify deployment site.",
      connectToNew: "Create a new deployment site on Netlify",
    },
    labels: {
      selectAccount: "Select Netlify team",
      selectSite: "Choose a Netlify site to publish to",
      siteName: "Netlify deployment site name",
      sitePlaceholder: "Find a site...",
    },
    messages: {
      authorizingNetlify:
        "We just opened a new browser window to authorize with Netlify. Accidentally closed the window?",
      connectToNewSiteCallout:
        "Want to connect this Gatsby Cloud site to a new Netlify deployment site? <button>Click here</button>",
      connectToExistingSiteCallout:
        "Want to connect this Gatsby Cloud site to an existing Netlify deployment site? <button>Click here</button>",
      accountValidateRequired: "You have to select a Netlify team.",
      siteValidateRequired: "You have to pick a Netlify site.",
      siteNameValidateRequired: "You have to enter a Netlify site name.",
      siteNameValidateFormat:
        "Only alphanumeric characters and hyphens are allowed.",
      loadingSites: "Loading your sites...",
      noSites: "No sites found",
      noMatchingSites: "No matching sites found",
      siteCreationFailed: "Unable to create Netlify site",
    },
  },
  firebaseIntegrationConfig: {
    actions: {
      connect: "Connect",
    },
    headers: {
      connectToSite: "Connect Firebase to <strong>{siteName}</strong>",
      noProjects: "No projects found on Firebase",
    },
    labels: {
      selectProject: "Select project",
      firebaseProject: "Choose a Firebase project for deployment",
      firebaseSiteName:
        "Enter a Firebase site name (for projects with multiple sites)",
    },
    messages: {
      authorizingFirebase:
        "We just opened a new browser window to authorize with Firebase. Accidentally closed the window?",
      projectCreationInstructions:
        "Create a Firebase project at <link>https://console.firebase.google.com</link>",
    },
  },
  vercelIntegrationConfig: {
    actions: {
      connect: "Connect",
      create: "Create",
      switchToExistingSite:
        "Click here to connect to an existing Vercel deployment",
      switchToNewSite: "Click here to connect to a new Vercel deployment",
    },
    headers: {
      connectToSite: "Connect Vercel to <strong>{siteName}</strong>",
      connectToNew: "Create a new deployment on Vercel",
      connectToExisting:
        "Connect this Gatsby Cloud site to an existing Vercel deployment",
    },
    labels: {
      vercelProjectTeam: "Vercel team",
      teamPersonalLabel: "Personal Account",
      vercelProjectName: "Vercel project name",
      vercelProjectId: "Choose a Vercel project to publish to",
      selectProject: "Select project",
    },
    messages: {
      authorizingVercel:
        "We just opened a new browser window to authorize with Vercel. Accidentally closed the window?",
      connectToNewSiteCallout:
        "Want to connect this Gatsby Cloud site to a new Vercel project? <button>Click here</button>",
      connectToExistingSiteCallout:
        "Want to connect this Gatsby Cloud site to an existing Vercel project? <button>Click here</button>",
      projectNameValidateFormat:
        "Only alphanumeric characters and hyphens are allowed.",
    },
  },
  azureIntegrationConfig: {
    labels: {
      azureConnectionString: "Connection String",
      azureStorageAccount: "Storage Account Name",
    },
    messages: {
      introText: "Set up deployment target",
    },
  },
  gcloudStorageIntegrationConfig: {
    labels: {
      gcsProjectId: "Project ID",
      gcsKeyData: "Service Account Key",
      gcsBucket: "Bucket Name",
      gcsFileKeyPrefix: "File Key Prefix",
    },
    messages: {
      introText: "Set up deployment target",
      gcsKeyDataDescription: "JSON format. Requires Storage Object Admin",
    },
  },
  fastlyIntegrationConfig: {
    labels: {
      fastlyToken: "Fastly API token",
      fastlyServiceName: "Fastly service name",
      fastlyHostName: "Fastly host name",
      fastlyForceSSL: "Force TLS/SSL",
      fastlyTlsKey: "Private Key",
      fastlyTlsCert: "Certificate",
    },
    messages: {
      introText: "Set up deployment target",
    },
  },
  amazonS3IntegrationConfig: {
    labels: {
      s3AccessKeyID: "Access Key ID",
      s3SecretAccessKey: "Secret Access Key",
      s3BucketName: "Bucket Name",
      s3FileKeyPrefix: "File Key Prefix",
      s3CloudFrontDistributionId: "CloudFront Distribution ID",
      s3InvalidationPaths: "CloudFront Invalidation Paths",
    },
    messages: {
      introText: "Set up deployment target",
    },
  },
  imageCdnIntegrationConfig: {
    headers: {
      images: "Images",
    },
    labels: {
      headerText: "Image CDN",
      enableImageCdnText: "Enable Image CDN",
      disableImageCdnText: "Image CDN enabled",
      learnAboutImageCdn: "Learn about Image CDN",
      usageHeaderText: "OPTIMIZED IMAGES",
    },
    messages: {
      toggleInfoText: "Lightning fast images powered by Gatsby Cloud",
      tooltipLabel: "images",
      bannerText: "Remember to upgrade your source plugins.",
      imageCdnEncryptionSuccessBannerText:
        "Your site meets dependency requirements, and is not vulnerable to the recently discovered Image CDN vulnerability.",
      imageCdnEncryptionFailureBannerText:
        "Your site does not meet the minimum dependency requirements to address the recently discovered Image CDN vulnerability.  To fix, follow the steps provided in our recent communication, or disable Image CDN.",
      loadingDetails: "Loading details...",
      bannerUpgradeText: "Image CDN isn't available on your plan.",
      bannerUpsellText: "Image CDN requires Gatsby 4 or higher",
      upgradePlan: "Upgrade plan",
      readMore: "Read more",
      shareFeedback: "Share feedback",
      imagesAtEdge:
        "Eliminate image processing and optimize images at the edge.",
      responsiveImageInMultipleSizes:
        "Responsive images in multiple sizes and formats.",
      onlyAvailableOnPaidPlans:
        "Only available on paid plans. <link>Upgrade</link>",
      upgradeSourcePlugins:
        "Upgrade source plugins and migrate to gatsbyImage. <link>Read more</link>",
      requiresGatsby4: "Requires Gatsby 4 or higher. <link>Read more</link>",
    },
  },
  gatsbyCloudCdnIntegrationConfig: {
    actions: {
      addDomain: "Add domain",
      enable: "Turn on",
      disable: "Turn off",
      useCustomCertificate: "Use custom certificate",
      remove: "Remove",
      makePrimary: "Make primary",
      redirectPrimary: "Redirect to Primary",
      removeRedirect: "Remove Primary Redirect",
      edit: "Edit",
      checkStatus: "Check Status",
      viewDetails: "View details",
      requestCertificate: "Turn on automatic certificates",
      requestCertificateAgain: "Re-request certificate",
    },
    headers: {
      setupGatsbyCloudCdn: "Deploy to Gatsby Hosting",
      connectedDomains: "Connected domains",
      sslCertificates: "SSL Certificates",
      removeDomain: "Remove domain",
      turnOnAutomaticCertificate: "Turn on automatic certificates",
      useCustomCertificate: "Use custom certificate",
      removeCertificate: "Remove certificate",
      addDomain: "Add Domain",
      turnOff: "Turn off?",
      makeDomainPrimary: "Make domain primary",
    },
    labels: {
      enableDeploys: `Enable deploys to Gatsby Hosting`,
      connected: "On",
      notConnected: "Off",
      connecting: "Connecting…",
      domainField: "Please enter a domain",
      certificate: "Certificate",
      privateKey: "Private key",
      intermediateCertificates: "Intermediate certificates",
      httpsOn: "HTTPS On",
      httpsFailed: "Certificate generation failed",
      sslCertificateRequested: "SSL Certificate requested",
      type: "Type",
      value: "Value",
      domains: "Domain(s)",
      created: "Created",
      expires: "Expires",
      serialNumber: "Serial Number",
      managed: "Managed by Gatsby Hosting",
      custom: "Custom Certificate",
      learnMoreAboutCustomDomain: "Learn more about custom domain",
    },
    messages: {
      features: ["Use your own domain", "Get a free SSL certificate"],
      success:
        "Have any question about Hosting? <link>Read our docs to learn more</link>.",
      questionsAboutHosting:
        "Questions about hosting? <link>Read our docs</link>.",
      certificateHint: "Place your PEM formatted certificate",
      privateKeyHint: "Place your private key",
      pleaseUpdateDnsRecord: "Please update your DNS records.",
      checkStatus: "Status changes can take up to 24 hours.",
      gatsbyCloudTurnedOn: "Gatsby Hosting turned on",
      gatsbyCloudTurnedOff: "Gatsby Hosting turned off",
      domainRemoved: "The <strong>{domain}</strong> domain removed.",
      managedCertificateTurnedOn:
        "Managed certificates for <strong>{domain}</strong> turned on",
      makeDomainPrimary: "The <strong>{domain}</strong> domain set as primary.",
      certificateRemoved: "The certificate removed.",
      domainAdded: "The <strong>{domain}</strong> domain added.",
      areYouSureYouWantToRemoveDomain:
        "Are you sure you want to remove the <strong>{domain}</strong> domain?",
      areYouSureYouWantToRemoveCertificate:
        "Are you sure you want to remove the certificate for domains(s) <strong>{domains}</strong>?",
      areYouSureYouWantToMakeDomainPrimary:
        "Are you sure you want to make <strong>{domain}</strong> primary?",
      mustBeValidDomainName: "This field must be a valid domain name",
      doYouWantToRemoveDomain: "Do you want to remove the {domain}?",
      doYouWantToRemoveCertificate:
        "Do you want to remove the certificate for domain(s): {domains}?",
      doYouWantToTurnOffGatsbyCloudCDN:
        "Do you want to turn off Gatsby Hosting?",
      doYouWantToMakeDomainPrimary: "Do you want to make the {domain} primary?",
      doYouWantToTurnOnAutomaticCertificate:
        "Do you want to turn on automatic certificates for <strong>{domain}</strong>?",
      doYouWantToTurnOnAutomaticCertificateAria:
        "Do you want to turn on automatic certificates for {domain}?",
      areYouSureYouWantToTurnOffGatsbyCloudCDN:
        "Are you sure you want to turn off Gatsby Hosting for <strong>{siteName}</strong>?",
      turnOffAutomaticCertificateWarning:
        "This will turn off automatic certificates and use your custom certificate instead.",
      notValidated: "Not validated",
      errorOccured: "An error occurred!",
      generatingSslCertificate: "Generating SSL certificate",
      sslCertificateAdded: "SSL certificate added",
      placeYourPrivateKey: "Place your private key",
      placeYourPemFormatedCertificate: "Place your PEM formatted certificate",
      placeYourCaCertificateChain: "Place your CA certificate chain",
      validating: "Validating...",
      loadingDetails: "Loading details...",
      generatingCertificate: "1/2 Certificate being generated",
      uploadingCertificate: "2/2 Uploading certificate to CDN",
      validationMustBeValidDomain: "This field must be a valid domain name",
      thisWillRemoveAndMakeDomainsUnavailable:
        "This will remove your site from our CDN such that users will not be able to access your site and will make the following domains unavailable until you set up another hosting integration:",
      youReachedMaxDomains:
        "You reached the max number ({maxDomains}) of custom domains per site",
    },
  },
  notificationDeploys: {
    headers: {
      noNotificationIntegrations: "No outgoing notifications",
      removeNotificationIntegration: "Remove a notification",
    },
    actions: {
      addNotification: "Add Notification",
      yesRemoveNotificationIntegration: "Yes, remove the notification",
    },
    labels: {
      slack: "Slack",
      email: "Email",
      webhooks: "Webhooks",
      prComment: "Pull-request comment",
      addWebhookDeployNotification: "Add an outgoing webhook",
      addSlackDeployNotification: "Add a Slack integration",
      addEmailDeployNotification: "Add an email notification",
      addPullRequestCommentDeployNotification:
        "Add a pull-request comment notification",
      eventToListen: "Event to listen",
      outgoingWebhooks: "Outgoing webhook URL:",
      eventTypePlaceholder: "Select an event",
      eventTypePreviewSucceeded: "Preview Succeeded",
      eventTypePreviewTimeOut: "Preview Timed Out",
      eventTypePreviewFailed: "Preview Failed",
      eventTypeBuildSucceeded: "Build Succeeded",
      eventTypeBuildFailed: "Build Failed",
      eventTypeBuildTimeOut: "Build Timed Out",
      eventTypeDeploySucceeded: "Deploy Succeeded",
      eventTypeDeployFailed: "Deploy Failed",
    },
    messages: {
      triggerHttpPostRequest:
        "Trigger an HTTP POST request to <a>{url}</a> when a <strong>{status}</strong>.",
      createPullRequestComment:
        "Create a pull-request comment when a <strong>{status}</strong>.",
      slackWebhook:
        "Send a messsage to a Slack channel when a <strong>{status}</strong>.",
      specificEventsIntro: "This will be triggered when:",
      buildSucceeded: "build succeeds",
      buildTimeout: "build times out",
      buildFailed: "build fails",
      previewSucceeded: "preview build succeeds",
      previewFailed: "preview build fails",
      previewTimeout: "preview times out",
      deploySucceeded: "deploy succeeds",
      deployFailed: "deploy fails",
      loadingNotificationDeploys: "Loading notifications",
      addNewIntegration:
        'To add a new outgoing notification, click on the "Add Notification" button.',
      notificationSuccessfullyCreated: "Notification successfully created",
      notificationSuccessfullyRemoved: "Notification successfully removed",
      removeNotificationIntegrationContent:
        "Are you sure you want to delete this notification?",
      failedToRemoveNotification: "Failed to remove this notification",
      webhookHint: "For example: https://my-services/webhooks/",
      webhookSlackHint:
        "For example: https://hooks.slack.com/services/T00000000/B00000000/XXXXXXXXXXXXXXXXXXXXXXXX",
    },
  },
  cmsPreview: {
    actions: {
      restart: "Restart preview",
      viewMoreActions: "More actions",
      clearCacheAndRestart: "Clear cache and restart",
    },
    headers: {
      previewBuildsDisabled: "Preview builds are disabled for this site",
    },
    messages: {
      previewBuildsDisabledDescriptionReadAccess:
        "Please contact the site's owner to enable preview builds",
      previewBuildsDisabledDescription:
        "Go to <link>Site Settings</link> to enable preview builds",
    },
  },
  acceptInvitation: {
    messages: {
      acceptingInvitation: "Accepting invitation…",
      loadingInvitation: "Loading invitation…",
    },
  },
  errorAlert: {
    headers: {
      defaultHeader: "Something went wrong",
    },
    messages: {
      somethingWentWrong: "Something went wrong",
      supportIntro: "Woops! Getting in trouble? — we are happy to help you!",
      supportContact:
        "If you need assistance, please contact our support team.",
    },
    actions: {
      contactSupport: "Contact Support",
    },
  },
  previewLoader: {
    headers: {
      error: "Oh no!",
    },
    messages: {
      loading: "Polishing your site...",
      loadingTooltip: "Building a new preview",
    },
  },
  workspaceBuildQueue: {
    headers: {
      buildQueueFor: "Build queue for <link>{name}</link>",
    },
    messages: {
      planIncludes:
        "Plan includes {number, plural, one {# concurrent build} other {# concurrent builds}}.",
      loadingBuilds: "Loading builds ...",
      thatsAll: " That's all. No more builds in the queue.",
      noBuildsInQueue: "No builds in queue",
    },
    labels: {
      learnMoreAboutConcurrency: "Learn more about concurrency",
      cancelBuild: "Cancel build",
      addMore: "Add more",
      addOn: "Add on",
      upgrade: "Upgrade",
    },
  },
  vcsHealth: {
    labels: {
      refresh: "Refresh",
      connected: "Connected",
      failed: "Failed",
    },
    messages: {
      vcsOrgDisconnectedOwnerVersion:
        "The connection to the VCS Org <strong>{name}</strong> in <strong>{source}</strong> has disconnected. Please restore your VCS Connection. This will open a window to complete the OAuth integration with <strong>{source}</strong>.",
      vcsOrgDisconnected:
        "Please contact your workspace owner to re-establish connection to <strong>{source}</strong>",
    },
  },
  siteTransfer: {
    headers: {
      transferSite: `Transfer billing`,
      cancelTransfer: "Cancel transfer?",
      resendEmail: "Resend email?",
      declineSiteTransfer: "Decline billing transfer",
    },
    messages: {
      transferThisSiteTo:
        "Transfer usage and billing for this site to a new or existing Gatsby Cloud account.",
      weUseThisInformatioToPersonalize:
        "We'll only use this information to personalize the invitation email.",
      transferSiteToNewAccount:
        "Transfer the billing for the site  <strong>{site}</strong> to a new or existing Gatsby Cloud account.",
      notAvailableToYourPlan: "Not available in your current plan.",
      clientWillReceiveEmail:
        "The client will receive an email inviting them to accept the billing transfer for the site. The email contains a link that's valid for <strong>{days}</strong>.",
      youWillRetainAccessToSite: "You will retain admin access to the site.",
      siteIsBeingTransferred:
        "This site billing is being transferred to <strong>{email}</strong>",
      siteIsTransferred: "The billing and usage have been transferred.",
      siteTransferEmailSentTo:
        "Billing transfer email sent to <strong>{email}</strong>",
      siteTransferEmailResentTo:
        "Billing transfer email re-sent to <strong>{email}</strong>",
      siteTransferCancelled:
        "Billing transfer to <strong>{email}</strong> cancelled",
      transferRestrictedToRoles:
        "You do not have permissions to transfer billing for this site. Please contact the workspace owner or admin.",
      areYourSureYouWantToCancelTransfer:
        "Are you sure you want to cancel the billing transfer.",
      areYourSureYouWantToResendEmail:
        "Are you sure you want to resend the email to <strong>{email}</strong>.",
      areYouSure: "Are you sure?",
      notAuthorized: "You're not authorized",
      senderWantsToTransferSite:
        "{senderName} wants to transfer billing for a site to you.",
    },
    labels: {
      transferSite: "Transfer billing",
      transferThisSite: "Transfer this site",
      clientEmail: "Client email",
      clientName: "Client name",
      learnAboutSiteTransfer: `Learn about billing transfer`,
      resendEmail: "Resend email",
      cancelTransfer: "Cancel transfer",
      canceling: "Canceling",
      resending: "Resending",
      upgradePlan: "Upgrade plan",
      decline: "Decline",
      upgrade: "Upgrade",
      or: "or",
      acceptTransfer: "Accept transfer",
      declineTransfer: "Decline transfer",
      dismissForNow: "Dismiss for now",
      createWorkspace: "Create a workspace",
      createNewOne: "Create a new one",
      reviewSiteTransfer: "Review Billing Transfer",
    },
  },
}
